<template>
  <v-card width="454" height="915px" outlined color="white" class="mainCard sigfloCard sigfloNeutralBorder200">
    <v-form ref="projectForm" submit-prevent>
      <v-card-title class="cardImage"> </v-card-title>
      <!-- <v-btn plain icon color="white" class="cardEllipsis"><v-icon>mdi-dots-horizontal</v-icon></v-btn> -->
      <div class="progressCircle">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="452"
          height="100"
          viewBox="0 0 452 100"
          fill="none"
          style="z-index: 0"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M116.486,60 C108.848,60,103.741,51.4247,104.365,43.8124 C104.454,42.7201,104.5,41.6154,104.5,40.5 C104.5,18.4086,86.5914,0.5,64.5,0.5 C42.4086,0.5,24.5,18.4086,24.5,40.5 C24.5,41.6154,24.5457,42.7201,24.6352,43.8124 C25.2592,51.4247,20.1523,60,12.5144,60 H3 C-2.52285,60,-7,64.4771,-7,70 V90 C-7,95.523,-2.52285,100,3,100 H453 C458.523,100,463,95.523,463,90 V70 C463,64.4772,458.523,60,453,60 H116.486 Z"
            fill="white"
          />
        </svg>
        <v-avatar size="80" color="white" class="progressCircleAvatar">
          <v-progress-circular
            :color="getProgressColor(project.percentComplete)"
            :value="project.percentComplete"
            size="60"
            width="6"
            ><span class="progressCircleText">{{ project.percentComplete }}%</span></v-progress-circular
          >
        </v-avatar>
      </div>
      <v-card-text class="text-h4 mt-4 mb-8 textEmphasis sigfloH4">
        <div v-show="!showEditProject">
          <span>{{ project.name }}</span
          ><v-btn dark class="ml-4" color="#7C40DC" fab x-small elevation="0" @click="editProjectName"
            ><v-icon>mdi-pencil</v-icon></v-btn
          >
        </div>
        <div v-show="showEditProject" class="">
          <div class="d-flex ma-0 pa-0">
            <v-text-field
              ref="projectName"
              width="200"
              color="#BCB2CD"
              solo
              filled
              dense
              flat
              elevation="0"
              single-line
              label="Project Name"
              v-model="project.name"
              hint="Friendly Name for this Project"
              :rules="validation.required"
              @change="saveProject"
            ></v-text-field>
            <v-btn dark class="ml-4" color="success" fab x-small elevation="0"><v-icon>mdi-check</v-icon></v-btn>
          </div>
        </div>
      </v-card-text>
      <v-card-text class="px-8">
        <div v-for="setting in configurator.currentProject.projectSettingModels" :key="setting.name">
          <v-row class="mt-2">
            <span class="sigfloBodyMedium textEmphasis">{{ setting.name }}</span>
          </v-row>
          <v-row class="mb-4">
            <v-text-field
              v-if="setting.controlType.toLowerCase() === 'int'"
              solo
              filled
              flat
              dense
              single-line
              v-model="setting.value"
              :rules="validation.intRule"
              :suffix="setting.valueSuffix"
              :label="setting.label"
              value=""
              :hint="setting.description"
              @input="validateForm"
            ></v-text-field>
            <v-text-field
              v-if="setting.controlType.toLowerCase() === 'multidecimal'"
              solo
              filled
              flat
              dense
              single-line
              v-model="setting.value"
              :rules="validation.decRule"
              :suffix="setting.valueSuffix"
              :label="setting.name"
              value=""
              :hint="setting.description"
              @input="validateForm"
            ></v-text-field>
            <v-select
              v-if="setting.controlType.toLowerCase() === 'dropdownlist'"
              solo
              filled
              flat
              dense
              single-line
              v-model="setting.value"
              persistent-hint
              :items="getProjectSettingValueModels(setting)"
              item-text="label"
              item-value="value"
              :label="setting.name"
              @input="validateForm"
              @change="saveProject"
            ></v-select>
            <v-select
              v-if="setting.controlType.toLowerCase() === 'multiselect'"
              solo
              filled
              flat
              dense
              single-line
              :value="setting.value ? setting.value.split(',') : null"
              :items="setting.projectSettingValueModels"
              attach
              chips
              :label="setting.label"
              :hint="setting.description"
              multiple
              item-text="label"
              item-value="value"
              :rules="validation.selection"
              deletable-chips
              @change="updateProjectSettingModel($event, setting)"
              @input="validateForm"
            >
              <template v-slot:selection="{ item, index }">
                <v-chip
                  :key="index"
                  close
                  @click:close="removeItem(item, index)"
                  class="custom-chip"
                  color="#bcb2cd"
                  dark
                >
                  {{ item.value }}
                </v-chip>
              </template>
            </v-select>
            <v-checkbox v-if="setting.controlType.toLowerCase() === 'yesno'" v-model="setting.value"></v-checkbox>
          </v-row>
        </div>
        <v-row class="mt-2">
          <v-col cols="6" class="py-0 pr-1 px-0">
            <span class="sigfloBodyMedium textEmphasis">Budget</span>
          </v-col>
          <v-col cols="6" class="pa-0 pl-1">
            <span class="sigfloBodyMedium textEmphasis">Install Date</span>
          </v-col>
        </v-row>
        <v-row class="mb-4">
          <v-col cols="6" class="pa-0 pr-1">
            <v-text-field
              width="200"
              color="#BCB2CD"
              solo
              filled
              dense
              flat
              elevation="0"
              single-line
              label="Budget"
              v-model="formattedBudget"
              hint="Budget for this project"
              :rules="validation.numeric"
              @change="saveProject"
            ></v-text-field>
          </v-col>
          <v-col cols="6" class="pa-0 pl-1">
            <v-menu
              ref="completionDateMenu"
              v-model="completionDateMenu"
              :close-on-content-click="true"
              transition="scale-transition"
              label="Install Date"
              offset-y
              max-width="290px"
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  readonly
                  solo
                  filled
                  dense
                  flat
                  color="#BCB2CD"
                  v-model="dateFormatted"
                  label=""
                  hint="Planned installation date"
                  v-bind="attrs"
                  v-on="on"
                  @change="completionDate = parseDate(dateFormatted)"
                ></v-text-field>
              </template>
              <v-date-picker
                light
                v-model="completionDate"
                solo
                filled
                dense
                flat
                color="primary"
                @input="completionDateMenu = false"
                @change="saveProject"
              ></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>

        <v-row class="mt-2">
          <span class="sigfloBodyMedium textEmphasis">Notes</span>
        </v-row>
        <v-row>
          <v-textarea
            solo
            filled
            dense
            flat
            rows="8"
            label="Type here..."
            single-line
            v-model="project.notes"
            hint="Enter notes about your project here"
            @change="saveProject"
          ></v-textarea>
        </v-row>

        <v-row>
          <v-spacer />
          <v-col class="text-right px-0">
            <v-btn
              rounded
              text
              color="#625676"
              @click="confirmDeleteProject"
              class="sigfloButtonSmall400 text-capitalize"
              ><v-icon class="ml-1">mdi-delete-outline</v-icon></v-btn
            >
          </v-col>
        </v-row>
      </v-card-text>
      <v-spacer />
      <v-card-actions class="projectCardActions">
        <div class="sigfloBodyLarge textMuted ml-2">Total:<br />${{ formatPrice(project.sellPrice) }}</div>
        <v-spacer />
        <div class="mr-2">
          <v-btn rounded elevation="0" color="rgb(50, 255, 152)" class="mt-4 text-capitalize" @click="navToCheckoutPage"
            >Check Out<v-icon class="ml-2">mdi-cart</v-icon></v-btn
          >
        </div>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
  import { mapState } from 'vuex';
  import moment from 'moment';
  export default {
    props: {
      project: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        completionDateMenu: false,
        showEditProject: false
      };
    },
    methods: {
      editProjectName() {
        this.showEditProject = !this.showEditProject;
        if (this.showEditProject) {
          this.$nextTick(() => {
            this.$refs.projectName.focus();
            this.$refs.projectName.$el.querySelector('input').setSelectionRange(0, this.project.name.length);
          });
        }
      },
      parseDate(dateString) {
        return moment(dateString, 'MMMM DD YYYY').toDate().toISOString().substring(0, 10);
      },
      getSettingValue(setting) {
        const settingValueModel = setting.projectSettingValueModels.find((x) => x.value == setting.value);
        if (settingValueModel) return settingValueModel.label;
        else return setting.value;
      },
      /**
       * Validates the form by calling the `validate` method on the `projectForm` ref.
       */
      validateForm() {
        this.formValid = this.$refs.projectForm.validate();
      },
      /**
       * Builds the dropdown list objects for specified setting
       */
      getProjectSettingValueModels: function (setting) {
        var items = [...setting.projectSettingValueModels];
        return items;
      },
      /**
       * Confirms the deletion of the project.
       *
       * @returns {void}
       */
      confirmDeleteProject: function () {
        const message = `Delete Project ${this.project.name}?`;
        this.showPlainDialog({
          display: 'Now',
          message: message,
          messageTitle: 'Confirm',
          parentId: 0,
          parentType: '',
          published: true,
          buttonArray: [
            {
              label: 'Delete',
              callback: this.deleteProject,
              icon: 'mdi-close',
              color: 'red'
            },
            {
              label: 'Cancel',
              callback: this.closePlainDialog,
              icon: '',
              color: 'grey'
            }
          ]
        });
      },
      /**
       * Saves the project by validating the form inputs and dispatching an action to create a new project.
       * If the form is valid, the project details are gathered and a new project object is created.
       * The new project object is then dispatched to the store to create the project.
       * After the project is created, the create new project dialog is closed, the list of projects is updated,
       * and the newly created project is opened.
       * Finally, the default project settings are reset.
       */
      saveProject: function () {
        if (this.$refs.projectForm.validate()) {
          this.$store.commit('configurator/setCurrentProjectLoading', true);
          this.$store.dispatch('configurator/updateProject', this.project).then(() => {
            this.$store.commit('configurator/setCurrentProjectLoading', false);
            this.$store.dispatch('app/showSuccess', 'Project saved');
            this.$store.dispatch('configurator/getProjects');
            this.showEditProject = false;
          });
        }
      }
    },
    computed: {
      ...mapState(['configurator']),
      formattedBudget: {
        get() {
          if (this.project.budget === '') return '';
          return this.project.budget.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        },
        set(value) {
          this.project.budget = value.replace(/,/g, '');
        }
      },
      completionDate: {
        get() {
          if (!this.project.completionDate) return new Date().toISOString().substring(0, 10);
          else return new Date(this.project.completionDate).toISOString().substring(0, 10);
        },
        set(value) {
          this.project.completionDate = value;
        }
      },
      dateFormatted: {
        get() {
          if (!this.project.completionDate) return '';
          else return moment(this.project.completionDate).format('MMMM DD YYYY');
        },
        set(value) {
          this.completionDate = this.parseDate(value);
        }
      }
    }
  };
</script>

<style scoped>
  .v-btn--outlined .v-btn__content .v-icon,
  .projectCardActions {
    padding-top: 60px;
  }
  .mainCard {
    position: relative;
  }
  .cardImage {
    height: 101px;
    background-image: url('~@/assets/images/podcast.png');
    background-size: cover;
    border-top-right-radius: 20px;
    border-top-left-radius: 20px;
    opacity: 0.8;
    clip-path: url(#clipShape);
    /* mix-blend-mode: soft-light; */
  }
  .cardEllipsis {
    position: absolute;
    top: 5px;
    right: 5px;
    margin: 0.5rem;
    z-index: 1;
  }
  .secondColumn {
    text-align: right;
  }
</style>
